<div class="modal-wrapper" #wrapper *ngIf="shouldRender">
  <app-three-sixty-viewer-core
    class="viewer-fullscreen"
    [images]="images"
    [minimal]="true"
  ></app-three-sixty-viewer-core>

  <button class="exit-btn" (click)="close()">
    <i nz-icon nzType="fullscreen-exit" nzTheme="outline"></i>
  </button>
</div>
